import ApiKeysForm from "src/components/profile/ApiKeysForm";
import ProfileLayout from "src/components/profile/ProfileLayout";

const ApiKeys = () => {
  return (
    <ProfileLayout activeKey="api_keys">
      <ApiKeysForm />
    </ProfileLayout>
  );
};

export default ApiKeys;